module.exports = __webpack_public_path__ + "img/type3.fae69c98.jpg";